/* eslint-disable camelcase */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Panel } from 'react-bootstrap';
import SellItPerformances from './sell-it/sell-it-performances';
import StockItPerformances from './stock-it';
import PriceItPerformances from './price-it';
import DisplayItPerformances from './display-it';

import expand from '../../assets/img/performances/Expand@2x.png';
import collapse from '../../assets/img/performances/Collapse@2x.png';

class ObjectivePerformances extends Component {
  render() {
    const {
      performances, pages, panelRefs, openPanels, handleClick, current_user
    } = this.props;
    const panelContent = {
      stock_it: <StockItPerformances performances={performances.stock_it} />,
      display_it: <DisplayItPerformances performances={performances.display_it} />,
      price_it: <PriceItPerformances performances={performances.price_it} />,
      sell_it: <SellItPerformances performances={performances.sell_it} current_user={current_user} />,
      ngp: <SellItPerformances performances={performances.ngp} current_user={current_user} />
    };

    return (
      <Row>
        <Col lg={12}>
          {Object.entries(pages).map(([key, label]) =>
            (
              <div
                key={key}
                ref={(element) => { panelRefs[key] = element; }}
              >
                <Panel
                  header={(
                    <div id={key} onClick={() => handleClick(key)}>
                      {label}
                      <img className="panel-toggle" src={openPanels.includes(key) ? collapse : expand} />
                    </div>)}
                  collapsible
                  expanded={openPanels.includes(key)}
                >
                  { openPanels.includes(key) && panelContent[key] }
                </Panel>
              </div>
            ))}
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = state => ({
  performances: state.stores.performances,
  current_user: state.viewConfig.profile,
});

export default connect(mapStateToProps)(ObjectivePerformances);



// WEBPACK FOOTER //
// ./src/components/store-performance/objective-performances.jsx